import LinkPage from 'components/_UI/LinkPage';
import Button from 'components/_UI/Button';
import Text from 'components/_UI/Text';
import CheckoutOrderMinimal from 'modules/checkout/products/CheckoutOrderMinimal';
import DescriptionWithHTML from 'modules/events/detail/DescriptionWithHTML';
import React, { useState, useEffect } from 'react'
import styled, { keyframes, css } from 'styled-components';
import { Column } from 'styled/alignment/Column';
import { Row } from 'styled/alignment/Row';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import ProducerCard from './ProducerCard';
import ProducerProfileCard from './ProducerProfileCard';
import ReportEvent from './ReportEvent';
import FaqList from 'modules/dashboard/events/detail/additional/faq/FaqList';
import SponsorSectionItems from './SponsorSectionItems';
import DynamicProfileImage from 'components/commons/DynamicProfileImage';
import { Heart, Users, Star, Eye } from 'lucide-react';

export default function PageContent({ data, faq, sponsorSections = [], participants = [], isAuth, participantsBlocked, likesStatus, currentUserId, onLikeParticipant }) {
    const hasTickets = (!!data?.products?.length && !data?.is_past) || (!!data?.link_ticket && !data?.is_past);
    const [activeTab, setActiveTab] = useState('details');
    const [socialFilter, setSocialFilter] = useState('all');
    const showSocialTab = isAuth;

    return (
        <Container>
            {
                !!data?.products?.length && !data?.is_past && (
                    <Side side='tickets'>
                        <CheckoutOrderMinimal event={data} />
                    </Side>
                )
            }

            {
                !!data?.link_ticket && !data?.is_past && (
                    <Side side='link_ticket'>
                        <LinkPage isWrapper to={data?.link_ticket} target={'_blank'}>
                            <Button>Garantir ingresso</Button>
                        </LinkPage>
                    </Side>
                )
            }

            <Side side='content' $fullWidth={!hasTickets}>
                {showSocialTab && (
                    <TabBar>
                        <Tab $active={activeTab === 'details'} onClick={() => setActiveTab('details')}>
                            Detalhes
                        </Tab>
                        <Tab $active={activeTab === 'social'} onClick={() => setActiveTab('social')}>
                            Social
                        </Tab>
                    </TabBar>
                )}

                {activeTab === 'details' ? (
                <>
                <Description>
                    <Column>
                        <Text name='title' paddingBottom={'20px'} color={colors.occasionalPurple}>Descrição</Text>
                    </Column>

                    {
                        data?.description_with_html
                            ? (
                                <DescriptionWithHtmlContainer>
                                    <DescriptionWithHTML data={data?.description_with_html} />
                                </DescriptionWithHtmlContainer>
                            ) : (
                                <Text
                                    color={colors.nightDark}
                                    marginTop='2px'
                                    marginBottom='16px'
                                >
                                    {data.description}
                                </Text>
                            )
                    }
                </Description>

                {
                    sponsorSections?.filter(section => section?.items?.length > 0).map(section => (
                        <ContentInfos key={section.id}>
                            <Text
                                name='subtitle'
                                type='bold'
                                color={colors.occasionalPurple}
                                marginBottom={'6px'}
                            >
                                {section.display_title}
                            </Text>

                            <SponsorSectionItems items={section.items} logoSize={section.logo_size} />
                        </ContentInfos>
                    ))
                }

                {
                    data?.spotify_embed_url && (
                        <ContentInfos>
                            <Text
                                name='subtitle'
                                type='bold'
                                color={colors.occasionalPurple}
                                marginBottom={'6px'}
                            >
                                Playlist do evento
                            </Text>
                            <SpotifyIframe
                                src={data.spotify_embed_url}
                                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                                loading="lazy"
                                title="Spotify playlist do evento"
                            />
                        </ContentInfos>
                    )
                }

                {
                    faq?.length > 0 &&
                    <ContentInfos>
                        <Text  name='subtitle'
                            type='bold'
                            color={colors.occasionalPurple}
                            marginBottom={'6px'}
                        >
                            Perguntas frequentes ({faq?.length})
                        </Text>

                        <FaqList faq={faq} />
                        
                    </ContentInfos>
                }

                {
                    !!data?.products?.length && (
                        <ContentInfos>
                            {/* <Divider
                                marginTop={'20px'}
                                marginBottom='15px'
                                color={colors.primaryDashboard}
                                opacity={0.3}

                            /> */}

                            <Text
                                // marginTop='10px'
                                name='subtitle'
                                type='bold'
                                color={colors.occasionalPurple}
                                marginBottom={'6px'}
                            >
                                Informações importantes
                            </Text>

                            <Text
                                // marginTop='10px'
                                name='highlight'
                                type='bold'
                                color={colors.nightDark}
                                marginBottom={'6px'}
                            >
                                Política de cancelamento de pedidos pagos
                            </Text>

                            <Text
                                marginBottom={'6px'}
                            >
                                Para realizar cancelamentos através do Whizr, é necessário estar atento ao prazo máximo de pedido.
                            </Text>

                            <Text marginBottom={'6px'} >
                                Conforme os termos de uso e os direitos do consumidor, a solicitação poderá ser realizada em até 7 dias corridos da compra, antecedendo o evento em pelo menos 48h.
                            </Text>

                            <Text marginBottom={'6px'}>
                                Em casos de políticas ofertadas diretamente pelos organizadores, serão eles os responsáveis pelo cumprimento das mesmas, assim como pelo reembolso e validações necessárias.
                            </Text>

                            <Text paddingBottom={0}>
                                Fique atento, e em caso de dúvidas sobre as políticas do evento, entre em contato com o organizador diretamente.
                            </Text>
                        </ContentInfos>
                    )
                }

                {data?.producer_profile?.id && (
                    <ContentInfos>
                        <Text
                            name='subtitle'
                            type='bold'
                            color={colors.occasionalPurple}
                            marginBottom={'6px'}
                        >
                            Sobre o produtor
                        </Text>

                        <ProducerProfileCard data={data?.producer_profile} />
                    </ContentInfos>
                )}

                {data?.establishment?.id && (
                    <ContentInfos>
                        <Text
                            name='subtitle'
                            type='bold'
                            color={colors.occasionalPurple}
                            marginBottom={'6px'}
                        >
                            Sobre o organizador
                        </Text>

                        <ProducerCard data={data?.establishment} />
                    </ContentInfos>
                )
                }

                <ReportEvent eventId={data?.id} />
                </>
                ) : (
                    <ContentInfos>
                        {participantsBlocked ? (
                            <BlockedMessage>
                                <Text
                                    name='subtitle'
                                    type='bold'
                                    color={colors.occasionalPurple}
                                    marginBottom={'8px'}
                                >
                                    Quer saber quem vai?
                                </Text>
                                <Text
                                    color={colors.nightDark}
                                    marginBottom={'6px'}
                                >
                                    Garanta seu ingresso para ver quem mais vai estar nesse evento e conecte-se com outros participantes!
                                </Text>
                            </BlockedMessage>
                        ) : (
                            <>
                                {/* Stats Banner */}
                                {likesStatus && (
                                    <StatsRow>
                                        <StatCard $variant="received">
                                            <StatIcon $variant="received">
                                                <Eye size={18} color="#fff" />
                                            </StatIcon>
                                            <StatValue>{likesStatus.received_likes || 0}</StatValue>
                                            <StatLabel>Curtida{(likesStatus.received_likes || 0) !== 1 ? 's' : ''} recebida{(likesStatus.received_likes || 0) !== 1 ? 's' : ''}</StatLabel>
                                        </StatCard>
                                        <StatCard $variant="matches">
                                            <StatIcon $variant="matches">
                                                <Star size={18} color="#fff" />
                                            </StatIcon>
                                            <StatValue>{likesStatus.matches?.length || 0}</StatValue>
                                            <StatLabel>Match{(likesStatus.matches?.length || 0) !== 1 ? 'es' : ''}</StatLabel>
                                        </StatCard>
                                        <StatCard $variant="remaining">
                                            <StatIcon $variant="remaining">
                                                <Heart size={18} color="#fff" />
                                            </StatIcon>
                                            <StatValue>{likesStatus.remaining_likes}</StatValue>
                                            <StatLabel>Curtida{likesStatus.remaining_likes !== 1 ? 's' : ''} restante{likesStatus.remaining_likes !== 1 ? 's' : ''}</StatLabel>
                                        </StatCard>
                                    </StatsRow>
                                )}

                                {/* Filter Tabs */}
                                <FilterBar>
                                    <FilterTab
                                        $active={socialFilter === 'all'}
                                        onClick={() => setSocialFilter('all')}
                                    >
                                        <Users size={14} />
                                        Todos
                                    </FilterTab>
                                    <FilterTab
                                        $active={socialFilter === 'liked'}
                                        onClick={() => setSocialFilter('liked')}
                                    >
                                        <Heart size={14} />
                                        Curtidos
                                    </FilterTab>
                                    <FilterTab
                                        $active={socialFilter === 'matches'}
                                        onClick={() => setSocialFilter('matches')}
                                    >
                                        <Star size={14} />
                                        Matches
                                    </FilterTab>
                                </FilterBar>

                                {(() => {
                                    const filtered = participants.filter((p) => {
                                        if (socialFilter === 'liked') return p.is_liked;
                                        if (socialFilter === 'matches') return p.is_match;
                                        return true;
                                    });

                                    return filtered.length > 0 ? (
                                        <ParticipantsGrid>
                                            {filtered.map((participant, index) => {
                                                const isLiked = participant.is_liked;
                                                const isMatch = participant.is_match;
                                                const isOwnCard = currentUserId && participant.id === currentUserId;
                                                const canLike = likesStatus && likesStatus.remaining_likes > 0 && !isLiked;

                                                return (
                                                    <ParticipantCard key={participant.id} $isMatch={isMatch} $index={index}>
                                                        <AvatarWrapper $isMatch={isMatch}>
                                                            <DynamicProfileImage
                                                                size='72px'
                                                                img={participant.avatar_thumb}
                                                                word={participant.first_name}
                                                            />
                                                            {isMatch && (
                                                                <MatchRing />
                                                            )}
                                                        </AvatarWrapper>
                                                        <ParticipantInfo>
                                                            <Text
                                                                name='small'
                                                                type='bold'
                                                                color={colors.nightDark}
                                                                paddingBottom={'0'}
                                                            >
                                                                {participant.first_name} {participant.last_name}
                                                            </Text>
                                                            <Text
                                                                name='small'
                                                                color={colors.night}
                                                                paddingBottom={'0'}
                                                            >
                                                                @{participant.username}
                                                            </Text>
                                                            {isMatch && (
                                                                <MatchBadge>
                                                                    <Star size={10} color="#fff" fill="#fff" />
                                                                    Match
                                                                </MatchBadge>
                                                            )}
                                                        </ParticipantInfo>
                                                        {!isOwnCard && likesStatus && (
                                                            <LikeButton
                                                                $liked={isLiked}
                                                                disabled={!canLike || isLiked}
                                                                onClick={() => !isLiked && onLikeParticipant(participant.id)}
                                                                aria-label={isLiked
                                                                    ? `Você curtiu ${participant.first_name}`
                                                                    : `Curtir ${participant.first_name}`
                                                                }
                                                            >
                                                                <Heart
                                                                    size={22}
                                                                    color={isLiked ? '#fff' : colors.occasionalPink}
                                                                    fill={isLiked ? '#fff' : 'none'}
                                                                />
                                                            </LikeButton>
                                                        )}
                                                    </ParticipantCard>
                                                );
                                            })}
                                        </ParticipantsGrid>
                                    ) : (
                                        <EmptyState>
                                            {socialFilter === 'liked' && (
                                                <>
                                                    <Heart size={40} color={colors.nightLight} />
                                                    <Text color={colors.night} marginTop='12px'>
                                                        Você ainda não curtiu ninguém neste evento.
                                                    </Text>
                                                </>
                                            )}
                                            {socialFilter === 'matches' && (
                                                <>
                                                    <Star size={40} color={colors.nightLight} />
                                                    <Text color={colors.night} marginTop='12px'>
                                                        Nenhum match ainda. Continue curtindo!
                                                    </Text>
                                                </>
                                            )}
                                            {socialFilter === 'all' && (
                                                <Text color={colors.night}>
                                                    Nenhum participante confirmado ainda.
                                                </Text>
                                            )}
                                        </EmptyState>
                                    );
                                })()}
                            </>
                        )}
                    </ContentInfos>
                )}
            </Side>
        </Container>
    )
}


const Container = styled(Column)`
  width: 100%;
  background-color: #fefefe;
  padding-bottom: 10px;
  
    @media screen and (min-width: ${breakpoints.lg}) {
        flex-direction: row-reverse;
        /* padding: 0 7%;  */
    }
`;

const Side = styled(Column)`
    padding: 20px 14px;
    
    @media screen and (min-width: ${breakpoints.lg}) {
        /* padding: 46px 40px; */

        ${({ side, $fullWidth }) => side === 'content' && `
            width: ${$fullWidth ? '100%' : '64%'};
        `}
        
        ${({ side }) => side === 'tickets' && `
            width: 36%;
            background-color: #fefefe;
            align-items: flex-end;
        `}

        ${({ side }) => side === 'link_ticket' && `
            width: 36%;
            background-color: #fefefe;
            align-items: flex-end;
            justify-content: center;
        `}
    }
    
`;

const Description = styled(Column)`
    align-items: center;
    text-align: left;  
    background: ${colors.neutralLight};
    /* box-shadow: 0 2px 5px #ccc; */
    box-shadow: 0 0 4px #ccc;
    padding: 30px;
    border-radius: 8px;
    border: 1px solid ${colors.neutralDark};
`;

const DescriptionWithHtmlContainer = styled(Column)`
`;

const ContentInfos = styled(Column)`
    /* padding: 0 6%; */
    background: ${colors.neutralLight};
    /* box-shadow: 0 2px 5px #ccc; */
    box-shadow: 0 0 4px #ccc;
    padding: 30px;
    border-radius: 8px;
    margin-top: 20px;
    border: 1px solid ${colors.neutralDark};
`;

const SpotifyIframe = styled.iframe`
    width: 100%;
    height: 352px;
    border-radius: 12px;
    border: none;
    margin-top: 8px;
`;

const TabBar = styled(Row)`
    width: 100%;
    margin-bottom: 20px;
    border-bottom: 2px solid ${colors.neutralDark};
`;

const Tab = styled.button`
    flex: 1;
    padding: 12px 0;
    border: none;
    background: none;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    color: ${({ $active }) => $active ? colors.occasionalPurple : colors.night};
    border-bottom: 3px solid ${({ $active }) => $active ? colors.occasionalPurple : 'transparent'};
    margin-bottom: -2px;

    &:hover {
        color: ${colors.occasionalPurple};
    }
`;

const fadeIn = keyframes`
    from { opacity: 0; transform: translateY(12px); }
    to { opacity: 1; transform: translateY(0); }
`;

const pulseHeart = keyframes`
    0% { transform: scale(1); }
    25% { transform: scale(1.3); }
    50% { transform: scale(0.95); }
    75% { transform: scale(1.15); }
    100% { transform: scale(1); }
`;

const shimmer = keyframes`
    0% { background-position: -200% center; }
    100% { background-position: 200% center; }
`;

const StatsRow = styled(Row)`
    gap: 10px;
    margin-bottom: 20px;
    width: 100%;
`;

const StatCard = styled(Column)`
    flex: 1;
    align-items: center;
    padding: 14px 8px;
    border-radius: 12px;
    background: ${({ $variant }) =>
        $variant === 'received' ? 'linear-gradient(135deg, #667eea, #764ba2)' :
        $variant === 'matches' ? `linear-gradient(135deg, ${colors.occasionalPurple}, ${colors.occasionalPink})` :
        'linear-gradient(135deg, #f093fb, #f5576c)'
    };
    box-shadow: 0 4px 14px ${({ $variant }) =>
        $variant === 'received' ? 'rgba(102,126,234,0.3)' :
        $variant === 'matches' ? 'rgba(105, 12, 228,0.3)' :
        'rgba(245,87,108,0.3)'
    };
`;

const StatIcon = styled.div`
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(255,255,255,0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 6px;
`;

const StatValue = styled.span`
    font-size: 22px;
    font-weight: 700;
    color: #fff;
    line-height: 1;
`;

const StatLabel = styled.span`
    font-size: 11px;
    font-weight: 600;
    color: rgba(255,255,255,0.85);
    margin-top: 2px;
    text-align: center;
`;

const FilterBar = styled(Row)`
    gap: 8px;
    margin-bottom: 20px;
    width: 100%;
`;

const FilterTab = styled.button`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 10px 12px;
    border-radius: 24px;
    border: 2px solid ${({ $active }) => $active ? colors.occasionalPurple : colors.neutralDark};
    background: ${({ $active }) => $active ? colors.occasionalPurple : '#fff'};
    color: ${({ $active }) => $active ? '#fff' : colors.night};
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.25s ease;

    &:hover {
        border-color: ${colors.occasionalPurple};
        color: ${({ $active }) => $active ? '#fff' : colors.occasionalPurple};
    }
`;

const ParticipantsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
    width: 100%;

    @media screen and (min-width: ${breakpoints.lg}) {
        grid-template-columns: repeat(3, 1fr);
    }
`;

const ParticipantCard = styled(Column)`
    align-items: center;
    padding: 20px 10px 14px;
    border-radius: 16px;
    border: 1.5px solid ${({ $isMatch }) => $isMatch ? 'transparent' : colors.neutralDark};
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;
    animation: ${fadeIn} 0.4s ease both;
    animation-delay: ${({ $index }) => ($index || 0) * 0.05}s;

    ${({ $isMatch }) => $isMatch && `
        background: linear-gradient(135deg, rgba(105, 12, 228,0.06), rgba(255,66,122,0.06));
        border-color: ${colors.occasionalPurple};
    `}

    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 24px rgba(105, 12, 228,0.12);
    }

    &:active {
        transform: translateY(-1px);
    }
`;

const AvatarWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const MatchRing = styled.div`
    position: absolute;
    inset: -4px;
    border-radius: 50%;
    border: 2.5px solid transparent;
    background: linear-gradient(135deg, ${colors.occasionalPurple}, ${colors.occasionalPink}) border-box;
    -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
`;

const ParticipantInfo = styled(Column)`
    align-items: center;
    margin-top: 10px;
    text-align: center;
`;

const BlockedMessage = styled(Column)`
    align-items: center;
    text-align: center;
    padding: 30px 16px;
`;

const EmptyState = styled(Column)`
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    text-align: center;
`;

const MatchBadge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-top: 6px;
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    color: #fff;
    background: linear-gradient(135deg, ${colors.occasionalPurple}, ${colors.occasionalPink});
    background-size: 200% auto;
    animation: ${shimmer} 3s linear infinite;
`;

const LikeButton = styled.button`
    border: none;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-top: 10px;
    cursor: ${({ disabled }) => disabled ? 'default' : 'pointer'};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    background: ${({ $liked }) => $liked
        ? `linear-gradient(135deg, ${colors.occasionalPurple}, ${colors.occasionalPink})`
        : 'rgba(255,66,122,0.08)'
    };
    opacity: ${({ disabled, $liked }) => (disabled && !$liked) ? 0.35 : 1};
    box-shadow: ${({ $liked }) => $liked
        ? '0 4px 12px rgba(255,66,122,0.35)'
        : 'none'
    };

    ${({ $liked }) => $liked && css`animation: ${pulseHeart} 0.5s ease;`}

    &:hover:not(:disabled) {
        transform: scale(1.15);
        background: ${({ $liked }) => $liked
            ? `linear-gradient(135deg, ${colors.occasionalPurple}, ${colors.occasionalPink})`
            : 'rgba(255,66,122,0.15)'
        };
    }

    &:active:not(:disabled) {
        transform: scale(0.9);
    }
`;